import { useCallback, useContext } from 'react';
import ReportsContext from '../../../../../../contexts/ReportsContext';
import usesFieldInPlates from './usesFieldInPlates';
import _ from 'lodash';
const useGetFieldReportFilterUsage = () => {
  const { allReports } = useContext(ReportsContext);

  const getFieldReportFilterUsage = useCallback(
    (field: string, dataset: string) => {
      const matches = allReports.filter((r) => {
        return (
          usesFieldInPlates(r.scope, field, dataset) ||
          usesFieldInPlates(r.drillDowns, field, dataset)
        );
      });
      return _.uniqBy(matches, 'id');
    },
    [allReports],
  );

  return getFieldReportFilterUsage;
};

export default useGetFieldReportFilterUsage;
